import type { HandId } from '@store/handStore';

/**
 * Non-reactive per-frame bend value in cents, per hand.
 *
 * The bend tracker writes here every frame. Consumers (HUD, future
 * visualizers) should read in their own rAF loop — NEVER subscribe. This
 * deliberately sits outside Zustand so 30-fps pitch updates don't re-render
 * React subtrees. Mode transitions (bend on/off) stay in `gestureStore`
 * because they're infrequent and subscribers do want to know.
 */
export const liveBend: Record<HandId, number> = {
  left: 0,
  right: 0,
};
